import { NuxtHTTPInstance } from '@nuxt/http';

import apiUrls from '@/apiUrls.config';
import { IRouteInfo } from '~/types/IRouteInfo';

export const czyJestRoute = async (http: NuxtHTTPInstance, path: string): Promise<IRouteInfo> => {
  const removeLastChar = path !== '/' && path.slice(-1) === '/';

  if (removeLastChar) path = path.substring(0, path.length - 1);

  const res: IRouteInfo = await http.$get(`${apiUrls.routing}/czy-jest-route?route=${path}`);

  return res;
};
